import React, { useEffect, useState } from "react";

import {
  FormSection,
  TextInput,
} from "../../../components";

export default function FormPesquisaPorAnimal({ handleConsulta }) {
  const [consulta, setConsulta] = useState("");
  const [depsOpen, setDepsOpen] = useState(true);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setConsulta({ ...consulta, [name]: value });
  };

  useEffect(() => {
    handleConsulta(consulta);
    // eslint-disable-next-line
  }, [consulta]);

  return (
    <div className="main-content">
      <FormSection title="Pesquisa por Animal" borderBottomWidth={376}>
        <TextInput
          placeholder="Série"
          name="serie"
          onChange={(value) => handleInput(value)}
        />

        <TextInput
          placeholder="RGN"
          name="rgn"
          onChange={(value) => handleInput(value)}
        />

        <TextInput
          placeholder="RGD"
          name="rgd"
          onChange={(value) => handleInput(value)}
        />

        <TextInput
          placeholder="Nome"
          name="nome"
          onChange={(value) => handleInput(value)}
        />
      </FormSection>
    </div>
  );
}
